




































import { Component, Vue } from 'vue-property-decorator';
import SaveButton from '@/components/App/SaveButton.vue';
import axios from 'axios';
import env from '@/env';
import WaveListItem from '@/components/Wave/WaveListItem.vue';

@Component({
  components: { WaveListItem, SaveButton }
})
export default class WavesView extends Vue {
  goToNewWave() {
    const scrollTo = document.getElementById('newWave');
    if (scrollTo) this.$vuetify.goTo(scrollTo);
  }

  async addWave() {
    const wave = await axios.post(`${env.backend_url}/wave/`);
    await this.$store.dispatch('refreshAllWaves');
    return wave;
  }

  async created() {
    this.$emit('showPreloader');
    await this.$store.dispatch('refreshAllWaves');
    this.$emit('loadingFinished');
  }
}
